import account from './reducers/account'
import user from './reducers/user'
import userList from './reducers/userList'
import log from './reducers/log'
import transaction from './reducers/transaction'
import trade from './reducers/trade'
import coins from './reducers/coins'
import auth from './reducers/auth'
import task from './reducers/task'
import common from './reducers/common'
import home from './reducers/home'
import contract from './reducers/contract'
import chat from './reducers/chat'
import settings from './reducers/settings'
import category from './reducers/category'
import product from './reducers/product'
import token from './reducers/token'
import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

export default combineReducers({
  account,
  coins,
  user,
  userList,
  transaction,
  log,
  task,
  trade,
  auth,
  common,
  home,
  contract,
  chat,
  settings,
  category,
  product,
  token,
  router: routerReducer
})



// WEBPACK FOOTER //
// ./src/reducer.js